<script setup lang="ts">
import { useVModel } from '@vueuse/core';

defineOptions({
  inheritAttrs: false,
});

const props = defineProps<{
  className?: string;
  modelValue?: string;
  multiple?: boolean;
}>();

const model = useVModel(props);
</script>

<template>
  <div class="relative">
    <select
      :class="[
        'peer inline-flex w-full cursor-pointer appearance-none items-center rounded-lg border bg-white border-input text-sm text-foreground shadow-xs shadow-black/5 transition-shadow focus disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 has-[option[disabled]:checked]:text-muted-foreground',
        multiple ? 'py-1 *:px-3 *:py-1 [&_option:checked]:bg-accent' : 'h-9 pe-8 ps-3',
        className,
      ]"
      v-bind="$attrs"
      ref="selectRef"
      v-model="model"
    >
      <slot></slot>
    </select>
  </div>
</template>
